<template>
  <div class="whole orders">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-date-picker style="float: left;"
          v-model="startDate"
          type="date"
          placeholder="请选择开始日期">
        </el-date-picker>
        <el-date-picker style="float: left;"
          v-model="endDate"
          type="date"
          placeholder="请选择截止日期">
        </el-date-picker>
        <el-select placeholder="请选择订单状态" v-model="state" style="float: left;">
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-input v-model="keywords" placeholder="请输入关键字" style="float: left;"></el-input>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
				<el-button @click="orderInfoExport" type="primary" style="float: left;">导出</el-button>
        <el-pagination
          background
          layout="total,prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table
          :data="orders"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column
             prop="orderNumber"
             label="订单编号"
             width="210">
           </el-table-column>
           <el-table-column
              prop="productName"
              label="商品名称"
              width="150">
            </el-table-column>
            <el-table-column
               prop="productSpec"
               label="商品规格"
               width="100">
             </el-table-column>
            <el-table-column
              props='productImg'
              label="商品图片"
              width="100">
              <template slot-scope="scope">
                <img :src="scope.row.productImg" class="product-img"/>
              </template>
             </el-table-column>
           <el-table-column
             prop="userName"
             label="下单人"
             width="100">
           </el-table-column>

		   <el-table-column
		   	prop="number"
		   	label="订单数量"
		   	width="100">
		   </el-table-column>
		   <el-table-column
		   	prop="unitPrice"
		   	label="单价"
		   	width="100">
		   </el-table-column>
		   <el-table-column
		   	prop="logisticsFee"
		   	label="运费"
		   	width="100">
		   </el-table-column>
		   <el-table-column
		     prop="orderAmountTotal"
		     label="总价格"
		     width="100">
		   </el-table-column>
<!--           <el-table-column-->
<!--             prop="uvalue"-->
<!--             label="产生Q值"-->
<!--             width="100">-->
<!--           </el-table-column>-->
           <el-table-column
             prop="orderShippingVo.contactName"
             label="收货人"
             width="100">
           </el-table-column>
           <el-table-column
             prop="orderShippingVo.contactPhone"
             label="联系方式"
             width="120">
           </el-table-column>
           <el-table-column
             prop="orderShippingVo"
             :formatter="handleAddressValue"
             label="收货地址"
             width="300">
           </el-table-column>
           <el-table-column
             prop="getType"
             :formatter="handleDeliveryValue"
             label="配送方式"
             width="100">
           </el-table-column>
		   <el-table-column
		     prop="logisticsName"
		     label="物流名称"
		     width="100">
		   </el-table-column>
		   <el-table-column
		     prop="logisticsNumber"
		     label="物流单号"
		     width="150">
		   </el-table-column>
           <el-table-column
             prop="insertTime"
             label="下单时间"
             width="200">
           </el-table-column>
           <el-table-column
             props='status'
             label="订单状态"
             width="100">
             <template slot-scope="scope">
                 <p>{{handleStatus(scope.row)}}</p>
             </template>
            </el-table-column>
            <el-table-column label="操作"
              show-overflow-tooltip>
               <template slot-scope="scope">
                 <el-button
                   size="mini"
                   @click="handleDispatch(scope.row)" v-if="scope.row.level==2&&scope.row.status==301">发货</el-button>
               </template>
             </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="发货物流填写"
        :visible.sync="dispatchVisible"
        width="30%"
        center
        :append-to-body=true>
        <el-form :label-position="left" label-width="100px" :model="controlData" :rules="rules" ref="addForm">
          <el-form-item label="物流">
            <el-select v-model="controlData.logisticsCompanyId">
              <el-option
                v-for="item in logisticsOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input v-model="controlData.logisticsNumber"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dispatchVisible = false">取 消</el-button>
          <el-button type="primary" @click="dispatch">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getAllOrders, dispatch, getLogistics,homeData11Export} from 'api/request'
import {ERR_OK} from 'api/config'
import {formatDate, loadingInstance, Success, Error,zOrderStatus,orderStatus} from 'common/js/util'
export default {
  components: { MSidebar,MHeader },
  data() {
    return {
      token:window.localStorage.getItem("token"),
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      state: '301',
      startDate: null,
      endDate: null,
      ca: null,
      //101：待支付  301：待发货  302：待收货  1：已完成  450：退换/售后
      stateOptions:[{
        value: '101',
        label: '待支付'
      }, {
        value: '301',
        label: '待发货'
      }, {
        value: '302',
        label: '待收货'
      }, {
        value: '1',
        label: '已完成'
      }, {
        value: '450',
        label: '退换/售后'
      }],
      logisticsOptions:[],
      supplierId: null,
      categoryId: null,
      keywords: "",
      dispatchVisible: false,
      deleteDialogVisible: false,
      detailDialogVisible: false,
      left: "left",
      addData: {},
      controlData: {},
      roundDatas: [],
      productDatas: [],
      multipleSelection: [],
      fileList: [],
      fileList1: [],
      fileyHeader: {},
      fileData: {
        type:1
      },

      orders:[]
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    }else{
      this.fileyHeader ={
        token:getUserInfo.token,
        'Content-Type': 'application/json;charset=utf-8'
      }
      this._getList();
      this._getLogistics();
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChange (val) {
      console.log(val)
      this.pageNum = val
      this._getList()
    },
    handleStatus(item){
      return item.level==1?orderStatus[item.status]:zOrderStatus[item.status];
    },
    handleDeliveryValue(row, column, cellValue, index) {
      //配送方式  1.物流   2.用户自提
      switch(cellValue){
        case 1:
          return "物流"
        case 2:
          return "用户自提"
      }
    },
    handleAddressValue(row, column, cellValue, index) {
      if (cellValue == undefined || cellValue == null) {
        return "";
      }
      return cellValue.province+cellValue.city+cellValue.county+cellValue.detailed
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.productDatas[index];
    },
    handleDispatch(row) {
      this.dispatchVisible = true;
      this.controlData.itemNumber = row.orderNumber;
    },
    dispatch() {
      let param = {
        itemNumber: this.controlData.itemNumber,
        logisticsCompanyId: this.controlData.logisticsCompanyId,
        logisticsNumber: this.controlData.logisticsNumber
      }
      loadingInstance(Loading);
      dispatch(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          Success(this, res);
          this._getList();
          this.dispatchVisible = false
        } else {
          Error(this, res);
        }
      });
    },
    handleEdit(index, row) {
      window.localStorage.setItem('productId',row.id);
      this.$router.push({
        path: '/addProduct'
      })
    },
    handleRemove(file, fileList) {
       console.log(file, fileList);
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    _deleteProduct(){
      let param = {
        id: this.controlData.id,
      }
      loadingInstance(Loading);
      deleteProduct(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList ();
        } else {
          Error(this, res);
        }
      })
    },
    _getLogistics () {
      let param = {
        current: this.pageNum,
        size: 100
      }
      loadingInstance(Loading)
      getLogistics(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.logisticsOptions = res.data
        } else {
          Error(this, res)
        }
      })
    },
    _getList () {
      let param = {
        state: this.state,
        startDate: this.startDate,
        endDate: this.endDate,
        content: this.keywords,
        current: this.pageNum,
        size: this.pageSize,
        orderType: 1
      }
      loadingInstance(Loading)
      getAllOrders(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.productDatas = res.data.records
          this.totalNum = res.data.total
          this.orders = res.data.records.map(item=>{
            let oneOrder = {
              id:item.orderNumber,
              orderNumber:item.orderNumber,
              orderAmountTotal:item.orderAmountTotal,
              uvalue:item.uvalue,
              orderShippingVo:item.orderShippingVo,
              getType: item.getType,
              insertTime:item.insertTime,
              status:item.status,
              productName:'',
              productSpec:"",
              productImg:'',
              userName:item.userName,
              level:1,
			  logisticsFee: item.logisticsFee
            }
            oneOrder.children = item.orderItemVos.map(c=>{
              return {
                id:c.itemNumber,
                orderNumber:c.itemNumber,
				number:c.number,
                orderAmountTotal:c.totalPrices,
                uvalue:c.uvalue,
                orderShippingVo:item.orderShippingVo,
                getType:item.getType,
                insertTime:c.insertTime,
                status:c.state,
                productName:c.umSkuVo.title,
                productSpec:c.umSkuVo.specialSpec,
                productImg:c.umSkuVo.images[0],
                userName:'',
                level:2,
				unitPrice:c.unitPrice,
				logisticsFee:c.logisticsFee,
				logisticsName:c.logisticsName,
				logisticsNumber:c.logisticsNumber
              }
            })
            return oneOrder;
          })
          if(res.data.pages>1){
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    },
		orderInfoExport() {
			location.href = homeData11Export+'userName='+this.keywords+"&startDate="+this.formatDate(this.startDate)+"&endDate="+this.formatDate(this.endDate)+"&type=3";
		},

		formatDate(date) {
			if (date != null && date != 'null' && date != undefined) {
				date = new Date(Date.parse(date)); //转换成Data();
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? '0' + m : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				return y + '-' + m + '-' + d;
			} else {
				return "";
			}

		}
  },
}
</script>
<style scoped>
  .orders .product-img{
    width: 90px;
  }

    .user{
      z-index: 9;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #F8F8F8;
    }
   .userOperate{
     height: 50px;
     margin-left: 10px;
     margin-right: 10px;
     margin-top: 30px;
     margin-bottom: 10px;
     box-sizing: border-box;
   }
   .userTable{
     padding: 10px;
     position: relative;
   }
</style>
<style>
  .orders table tr.el-table__row--level-0{
    background-color: #f7e7e7 !important;
  }
  .userOperate .el-input {
    width:180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .userOperate .el-button {
    width:100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/orders.vue